import { createStyle } from '@gluestack-style/react';

export const ProgressFilledTrack = createStyle({
  bg: '$primary500',
  borderRadius: '$full',
  _dark: {
    bg: '$primary400',
  },
});
